var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoIllness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 160,
    viewBox: "0 0 200 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "io6jt01nja",
    d: "M0 0.049L107.954 0.049 107.954 103.449 0 103.449z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H200V160H0z",
    transform: "translate(-526 -877) translate(32 22) translate(494 855)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.313
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-526 -877) translate(32 22) translate(494 855) translate(46 28) translate(0 .074)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hi732x26pb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#io6jt01nja"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F2818A",
    d: "M89.958.903c-2.66-.57-5.22-.854-7.634-.854-21.206 0-27.554 24.647-27.554 24.647-.437 1.704-1.171 1.709-1.626.007 0 0-6.376-23.753-27.312-23.753-2.474 0-5.113.285-7.846.876C6.616 4.251-1.652 19.429.28 34.326 3.731 60.773 51.56 102.58 51.56 102.58c1.328 1.161 3.495 1.158 4.82 0 0 0 47.836-41.817 51.29-68.253 1.965-15.102-6.47-31.031-17.71-33.423",
    mask: "url(#hi732x26pb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M58.724 93.97h-.063c-.8-.025-1.457-.567-1.557-1.281l-8.337-55.582-8.499 35.461c-.15.676-.807 1.17-1.575 1.18-.747-.035-1.445-.459-1.62-1.133l-4.603-17.71-2.523 5.143c-.26.533-.846.877-1.495.877H8.021c-.905 0-1.636-.655-1.636-1.465s.73-1.468 1.636-1.468h19.367l4.061-8.292c.283-.58.959-.937 1.646-.871.7.058 1.281.513 1.44 1.128l3.997 15.354 8.981-37.659c.155-.707.843-1.215 1.662-1.18.8.023 1.461.566 1.564 1.28l8.363 55.809 8.193-35.768c.146-.637.743-1.113 1.468-1.164.739-.057 1.398.33 1.654.94l4.096 9.684h25.422c.901 0 1.634.656 1.634 1.468 0 .81-.733 1.465-1.634 1.465H73.387c-.68 0-1.29-.378-1.53-.947l-2.498-5.908-9.04 39.466c-.151.686-.823 1.173-1.595 1.173",
    transform: "translate(-526 -877) translate(32 22) translate(494 855) translate(46 28)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIllness);
export default __webpack_public_path__ + "static/media/no-illness.97e291943f970dbf5b3c281587988ade.svg";
export { ForwardRef as ReactComponent };